import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  inject,
} from '@angular/core';
import { Nullable, Optional } from '@src/types/utils';

import { GroupedListType, ListActionType, ListMode, ListType } from './types';
import { getGroupsUsers } from './utils';

@Component({
  selector: 'app-new-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() mode: ListMode = 'single';
  @Input() items?: Nullable<Array<ListType>>;
  @Input() itemContentTmp?: TemplateRef<any>; // TODO: избавиться от any, был тип ListType. Возможно указан неверно
  @Input() itemActions?: ListActionType[];
  @Input() count?: number | null;
  @Input() withCounter = false;
  @Input() selectedId?: string;
  @Output() selectedIdChange = new EventEmitter<Optional<string>>();
  @Output() searchNextPage = new EventEmitter<void>();

  @Input() groupingEnable = false;
  groups: GroupedListType[] = [];

  loading = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.loading = this.items === null;
    }

    if (changes.groupingEnable || changes.items) {
      if (this.groupingEnable && this.items) {
        this.groups = getGroupsUsers(this.items);
      }
    }

    this.cdr.markForCheck();
  }

  onToggleItem(item: ListType) {
    if (item.id !== this.selectedId) {
      this.selectedId = item.id;
      this.selectedIdChange.emit(this.selectedId);
    }
  }

  onIntersection(intersection: IntersectionObserverEntry[]) {
    if (intersection[0].isIntersecting) {
      this.searchNextPage.emit();
    }
  }
}
